<template>
  <div>
    <div id="modalLineas" class="modal">
      <div class="modal-contenido rounded-xl p-1">
        <div class="grid grid-cols-6 justify-items-end">
          <button
            @click="clean()"
            type="button"
            class="col-start-6 end text-xl mx-2 p-1"
          >
            <a class="font-bold" href="#">X</a>
          </button>
        </div>
        <div class="w-full">
          <h4
            class="
              bg-gray-100
              mx-9
              mb-1
              text-2xl
              shadow-xl
              text-black text-center
              mt-1
              rounded
              divide-y divide-red-500
            "
          >
            Líneas
            <hr color="black" size="4" />
          </h4>
          
        </div>
        <!--<div
          class="border rounded-xl w-80 border-solid border-t-4 border-l-4 border-r-4 border- shadow-2xl"
        >-->
        <div class="">
          <div class="col-span-2 justify-center mt-2">
            <div class="px-10 mx-5">
              <p class="uppercase text-center divide-y text-sm">descripcion</p>
              <p
                class="divide divide-y mx-2 border-b-2 divide-black"
                v-if="!banderamodal"
              >
                <strong v-if="!valor">{{ descripcionmodal }} </strong>
              </p>
              <input
                v-model="descripcion"
                v-on:keyup="mostrar()"
                @keyup.enter="agregartable(), clean(), recargar()"
                v-if="valor"
                class="
                  appearance-none
                  w-full
                  mx-2
                  w-80
                  border-b-2 border-black
                  shadow-xl
                  block
                  col-span-3
                  bg-gray-lighter
                  text-grey-darker
                  rounded
                  py-1
                "
                id=""
                type="text"
              />
              <input
                v-model="descripcion"
                v-on:keyup="mostrar()"
                v-if="banderamodal"
                class="
                  appearance-none
                  w-full
                  mx-2
                  w-80
                  border-b-2 border-black
                  shadow-xl
                  block
                  col-span-3
                  bg-gray-lighter
                  text-grey-darker
                  rounded
                  py-1
                "
                id=""
                type="text"
              />
            </div>
          </div>

          <div class="inline flex justify-center">
            <div>
              <button
                v-if="!banderamodal"
                @click="mostrarinicial()"
                type="button"
                class="
                  w-full
                  inline-flex
                  justify-center
                  mt-5
                  rounded-md
                  border border-transparent
                  shadow-sm
                  px-2
                  py-1
                  bg-green-400
                  text-base
                  font-medium
                  text-white
                  hover:bg-green-300
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-green-500
                  sm:ml-3
                  sm:w-auto
                  sm:text-sm
                "
              >
                Modificar
              </button>
            </div>
            <div class="col-span-1 mx-2">
              <button
                @click="agregartable(), clean(), recargar()"
                type="button"
                class="
                
                  w-full
                  inline-flex
                  justify-center
                  mt-5
                  rounded-md
                  border border-transparent
                  shadow-sm
                  px-2
                  py-1
                  bg-blue-600
                  text-base
                  font-medium
                  text-white
                  hover:bg-blue-400
                  focus:outline-none
                  focus:ring-2 focus:ring-offset-2 focus:ring-blue-500
                  sm:ml-3
                  sm:w-auto
                  sm:text-sm
                "
              >
                <a href="#"> Guardar </a>
              </button>
              <button class="bg-blue400"></button>
            </div>
          </div>
        </div>
        <!--</div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";
//import axios from "axios";
export default {
  name: "modalLineas",
  data() {
    return {
      caracteristica: "",
      respuesta: null,
      idlinea: "",
      nombrelinea: "",
      value: null,
      descripcion: "",
      valor: false,
    };
  },
  mounted() {
    this.value = this.numero;
  },
  methods: {
    ...mapMutations("lineas", ["agregartable", "cargardatoslineas", "cambio"]),

    mostrar() {
      this.cambio(this.descripcion);
    },
    async recargar() {
      setTimeout(() => {
        this.cargardatoslineas();
      }, 500);
    },
    mostrarinicial() {
      this.descripcion = this.descripcionmodal;
      this.valor = true;
    },

    clean() {
      this.descripcion = null;
      this.valor = false;
    },
  },
  computed: {
    ...mapState("lineas", ["idmodal", "descripcionmodal"]),
    ...mapState([
      "elemento",
      "id",
      //"descripcion",
      "numero",
      // "idmodal",
      //"descripcionmodal",
      "banderamodal",
    ]),
  },
};
</script>
<style scoped >
.modal-contenido {
  background-color: rgb(255, 255, 255);
  width: 500px;
  height: auto;

  margin: auto;
  margin-top: 100px;
  position: relative;
}
.modal {
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 0.1s;
}
#modalLineas:target {
  opacity: 1;
  pointer-events: auto;
}
</style>

